<template>
  <div>
    <!-- UnloadStartDate -->
    <b-form-group
      label="Data de inicio da descarga"
      label-for="UnloadStartDate"
    >
      <b-form-input
        id="UnloadStartDate"
        type="date"
        placeholder="Data de inicio da descarga"
        v-model="model.unloadStartDate"
        :readonly="readonly"
      />
      <span class="text-danger" v-if="modelstate['UnloadStartDate']">
        {{ modelstate["UnloadStartDate"][0] }}
      </span>
    </b-form-group>
    <!-- UnloadStartHour -->
    <b-form-group
      label="Hora de inicio da descarga"
      label-for="UnloadStartHour"
    >
      <b-form-input
        id="UnloadStartHour"
        type="time"
        placeholder="Hora de inicio da descarga"
        v-model="model.unloadStartHour"
        :readonly="readonly"
      />
      <span class="text-danger" v-if="modelstate['UnloadStartHour']">
        {{ modelstate["UnloadStartHour"][0] }}
      </span>
    </b-form-group>
    <!-- <cargo-occurrence-attachments
        :model="model"
        :readonly="readonly"
        :occurrence-type-id="9"
    >
    </cargo-occurrence-attachments> -->
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
// import CargoOccurrenceAttachments from "@/components_rms/tracking/cargo/CargoOccurrenceAttachments.vue";

export default {
  name: "CargoCrudStatusWaitingUnload",
  components: {
    // CargoOccurrenceAttachments,
  },
  directives: {
    mask: AwesomeMask,
  },
  props: {
    model: Object,
    modelstate: Object,
    readonly: Boolean,
  },
};
</script>
